module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAbCAYAAABiFp9rAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAASJJREFUeNq0lu8NwiAQxWnjdztCNxA3YARHwA26ghs4Am5QN+gG1g0coU6AR70mBC1wQF/y+9C06YO7x59Ka90xxgZgZBuqBibgAbwABZw2cYIZGa76Vz0ggRa/ycJ+GPW6RhwMTzWqZrevGizfPlCEN9AjA5Y+KNvIiGO/KLqjYY8D9fbIRup0LSUWvh7ZKJ2vCf9jBt64pbNl1tWhQLBNT4UvKS2OKndW3Fe6BVHCJMbI0CWGgseEwS0h1aRx/1NHNJMTGv+cG/9nEZc0WjWJNRK5Jms7g0so4oq6e6cEQcXu3nVG2W6ApJywKUEgmaQaXagmMWFwJUsc5S68lEkoDHbZznhDyrpuhYyyTYx2nnctcCx1sfSdsK33skHUR4ABAFL2VZjGlIp7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/home/arrow1.png
// module id = TuCl
// module chunks = 51